<div class="container-fluid">
    <div class="row">
        <div class="col-12">
            <!-- <div class="page-title-box d-flex align-items-center justify-content-between">
                <h4 class="mb-0 font-size-18">Specific Risk Assessment Index</h4>
                <div class="page-title-right">
                    <ol class="breadcrumb m-0">
                        <li class="breadcrumb-item">
                            <a ng-reflect-router-link-active="active" routerLink="riskmanagement" data-parent="110"
                                href="/riskmanagement">Risk Management</a>
                        </li>
                        <li class="breadcrumb-item active">Specific Risk Assessment Index</li>
                    </ol>
                </div>
            </div> -->
            <div class="page-title-box row  align-items-md-center ">
                <div class="col-md-5 mb-2">
                    <h4 class="mb-0 font-size-18">Specific Risk Assessment Index</h4>
                </div>
                <div class="col-md-7">
                    <div class="float-end">
                        <ol class="breadcrumb m-0">
                            <li class="breadcrumb-item">
                                <a ng-reflect-router-link-active="active" routerLink="riskmanagement" data-parent="110"
                                    href="/riskmanagement">Risk Management</a>
                            </li>
                            <li class="breadcrumb-item active">Specific Risk Assessment Index</li>
                        </ol>
                    </div>
                </div>

            </div>
        </div>
    </div>

    <div class="row mb-md-2">
        <div class="col-md-3 form-group mb-3">
            <strong class="text-muted">Select for month</strong><br>
            <ng-select placeholder="Select Month" (change)="VHById($event,'month')" [items]="MonthList"
                bindValue="MonthList" bindLabel="MonthList" [(ngModel)]="defaultMonth">
            </ng-select>
        </div>
        <div class="col-md-3 form-group mb-3" *ngIf="auth.isOfficeUser">
            <strong class="text-muted">Vessel</strong><br>
            <ng-select [items]="vessel" placeholder="Select Vessel" (change)="VHById($event,'vesselId')"
                bindLabel="vessel" bindValue="id">
            </ng-select>
        </div>
        <div class="col-md-3 form-group mb-3" *ngIf="auth.isOfficeUser">
            <strong class="text-muted">Show R.A.s ID</strong><br>
            <ng-select [(ngModel)]="IsRaId" [items]="showRaId" bindLabel="key" bindValue="value"
                (change)="onChange($event)">
            </ng-select>
        </div>
        <div class="col-md-3 form-group mb-3" *ngIf="auth.isOfficeUser">
            <strong class="text-muted">Status</strong><br>
            <ng-select [items]="riskStatusList" placeholder="Select Status" (change)="VHById($event, 'status')"
                bindLabel="key" bindValue="value">
            </ng-select>

        </div>



    </div>
    <div class="row justify-content-end ">
        <div class="col-md-5 text-end">
            <button type="button" [disabled]="VesselHistorylist== null || VesselHistorylist.length==0"
                class="btn btn-primary ms-2" (click)="PrintPdf()"><i class="bx bx-printer fa-sm"></i>
                Print</button>
            <button type="button" [disabled]="VesselHistorylist== null || VesselHistorylist.length==0"
                class="btn btn-danger ms-2" (click)="downloadPdf()"><i class="bx bx-file-blank"></i>
                Pdf</button>
        </div>
    </div>
    <div class="container" id="VesselHistoryReport" #VesselHistoryReport>
        <div class="row">
            <h4 class="text-center mt-3">Fleet History </h4>
            <ng-container *ngFor="let VHlist of VesselHistorylist; let i = index">
                <div class="card" *ngIf="VHlist!= null">
                    <div class="row card-body">
                        <div class="row mb-3 pb-2 border-bottom">
                            <div class="col-lg-3 col-md-3 py-1">
                                <strong class="text-muted">Name of Month: &nbsp;&nbsp;</strong>
                                <span class="font-size-16">{{VHlist.RAlist[0]?.data[0]?.createdAt|date :'MMMM'}}</span>
                            </div>
                            <div class="col-lg-3 col-md-4 py-1 ">
                                <strong class="text-muted">No. of Risk Assessments: &nbsp;&nbsp;</strong>
                                <span class="font-size-16 ">{{VHlist.RACount}}</span>
                            </div>
                            <div class="col-lg-3 col-md-4 py-1 ">
                                <strong class="text-muted">No. of Vessels: &nbsp;&nbsp;</strong>
                                <span class="font-size-16 ">{{VHlist.RAlist.length}}</span>
                            </div>
                        </div>
                        <div *ngFor="let item of VHlist.RAlist">
                            <div class="row">
                                <div class="col-md-3">
                                    <strong class="text-muted ">Vessel: &nbsp;&nbsp;</strong>
                                    <span class="font-size-16 px-1">{{(item.vesselName != null && item.vesselName )?
                                        item?.vesselName:'--'}}</span>
                                </div>
                                <div class="col-md-3 ">
                                    <strong class="text-muted ">No of R.A.s:&nbsp;&nbsp;</strong>
                                    <span class="font-size-14 px-1">{{item.data?.length}}</span>
                                </div>
                            </div>
                            <div class="table-responsive">
                                <table id="basic-datatable " class="table dt-responsive nowrap no-footer dtr-inline ">
                                    <thead>
                                        <tr>
                                            <th class="font-size-16 w-25 ">ID</th>
                                            <th class="font-size-16 w-25 ">Date</th>
                                            <th class="font-size-16 ">Risk</th>
                                            <th class="font-size-16 ">Edits</th>
                                            <th class="font-size-16 ">Status</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr></tr>
                                        <tr *ngFor="let Risklist of item.data">
                                            <ng-container *ngIf="auth.isOfficeUser">
                                                <td *ngIf="IsRaId">{{Risklist.uniqueOperationId}}</td>
                                                <td *ngIf="!IsRaId">{{Risklist.operationId}}</td>
                                            </ng-container>
                                            <ng-container *ngIf="!auth.isOfficeUser">
                                                <td *ngIf="auth.currentUserValue?.isViewId">
                                                    {{Risklist.uniqueOperationId}}</td>
                                                <td *ngIf="!auth.currentUserValue?.isViewId">{{Risklist.operationId}}
                                                </td>
                                            </ng-container>
                                            <td>{{Risklist.createdAt ? (Risklist.createdAt|date:'dd-MMM-yyyy') :' -- '}}
                                            </td>
                                            <td>{{Risklist.riskLevel ? Risklist.riskLevel :' -- '}}</td>
                                            <td>{{Risklist.edits ? Risklist.edits :' -- '}}</td>
                                            <td>{{Risklist.status|keyfromvalue:RiskStatusEnum}}
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div> <br>
                    </div>
                </div>
            </ng-container>
            <div class="card" *ngIf="VesselHistorylist == null||VesselHistorylist.length == 0">
                <p class="text-center text-danger">
                    No Records Found
                </p>
            </div>
        </div>

    </div>

</div>